import Sticky from 'sticky-js';

var sticky = new Sticky('.stickyjs');